// src/components/QuoteSection.tsx
import React from "react";

const QuoteSection: React.FC = () => {
  return (
    <section className="bg-blue-200 py-16 px-8">
      <div className="max-w-4xl mx-auto text-center">
        {/* Quote */}
        <h2 className="text-2xl md:text-3xl font-semibold text-primary-lightBlue mb-6">
          "TrueMerge and the team at Blue Horse Data have been invaluable to our
          mail program. I am continually impressed by their speed and attention
          to detail in managing eight plus mailings per month for us across six
          brands."
        </h2>

        {/* Attribution */}
        <p className="text-gray-700 text-lg">
          - Associate Director of Offline Media, Major Subscription Meal Kit
          Company
        </p>
      </div>
    </section>
  );
};

export default QuoteSection;
